import { PagedSearch } from '../../../shared/model/paged-search.model';

export class UserSearchDto extends PagedSearch {
  UserName: string;
  Inactive: boolean;

  public constructor() {
    super();
    this.Inactive = false;
  }
}
